import { render, staticRenderFns } from "./RecordingControls.vue?vue&type=template&id=71a42590&scoped=true"
import script from "./RecordingControls.vue?vue&type=script&lang=js"
export * from "./RecordingControls.vue?vue&type=script&lang=js"
import style0 from "./RecordingControls.vue?vue&type=style&index=0&id=71a42590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a42590",
  null
  
)

export default component.exports